import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TableUsers from "./pages/TableUsers";
import RolesPermissions from './pages/RolesPermissions';
import Home from "./components/Home/home";
import Reunions from "./pages/Reunions";
import ReunionDetails from "./pages/ReunionDetail";
import MeetingRooms from "./pages/MeetingRooms";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import MeetPosts from "./pages/MeetPosts";
import ProfilePage from "./components/Admin/popups/ProfilePage";
import MeetingRoomManagers from "./pages/MeetingRoomManagers";
import NotificationsPage from "./components/NotificationsPage";
import MesReunion from "./pages/MesReunion";
import ComptesRendusPage from "./components/Manager/ComptesRendusPage";
import TachesPage from "./components/Manager/TachesPage";
import CompteRenduDetailPage from './components/Manager/CompteRenduDetailPage';
import MesTache from "./pages/MesTache";
import AdminReunions from "./pages/AdminReunions";

const App = () => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getRoleFromStorage = () => {
      try {
        const authData = localStorage.getItem("auth_data");
        if (authData) {
          const parsedData = JSON.parse(authData);
          const userRole = parsedData.role;
          console.log("👤 Rôle chargé depuis auth_data:", userRole);
          setRole(userRole);
        } else {
          const userRole = localStorage.getItem("userRole");
          console.log("👤 Rôle chargé depuis userRole:", userRole);
          setRole(userRole || "employee");
        }
      } catch (error) {
        console.error("Erreur chargement rôle:", error);
        setRole("employee");
      } finally {
        setLoading(false);
      }
    };

    getRoleFromStorage();

    // Écouter les changements dans localStorage
    const handleStorageChange = (e) => {
      if (e.key === "auth_data" || e.key === "userRole") {
        getRoleFromStorage();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#5e17eb] border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  console.log("🎯 Rôle final pour routing:", role);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />

        {/* Dashboard selon le rôle */}
        {/* <Route
          path="/dashboard"
          element={
            role === "Admin" ? <AdminDashboard /> :
              role === "Manager" ? <Dashboard /> :
                <MeetPosts />
          }
        /> */}
        <Route path="/dashboard" element={<Dashboard />} />

        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        {/* Routes pour Admin et Manager */}
        <Route path="/listeUtilisateurs" element={<TableUsers />} />
        <Route path="/roles-permissions" element={<RolesPermissions />} />

       
        
        <Route path="/AdminlisteReunions" element={<AdminReunions />} />

        <Route path="/listeReunions" element={<Reunions />} />
        <Route path="/comptes-rendus" element={<ComptesRendusPage />} />
        <Route path="/comptes-rendus/:id" element={<CompteRenduDetailPage />} />
        <Route path="/taches" element={<TachesPage />} />
        <Route path="/reunions/:id" element={<ReunionDetails />} />
        <Route path="/reunions/:id/live" element={<MeetingRoomManagers />} />

        {/* Routes pour Employé */}
        <Route path="/consulter-reunion/:id" element={<MeetingRooms />} />
        <Route path="/consulter-reunion" element={<MeetPosts />} />
        <Route path="/mes-reunions" element={<MesReunion />} />
        <Route path="/mes-taches" element={<MesTache />} />
        <Route path="/admin-reunions" element={<AdminReunions />} />

        {/* Routes communes */}
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;